import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {RouteContext} from "../../../RouteContext";
import React from "react";
import {CampaignPolicyIO} from "../../../../io/campaign/campaignPolicyIO";
import {CampaignPolicyValueObject} from "../../../../model/vo/campaign/CampaignPolicyValueObject";

const propertyDetail: DetailPagePropertyIndicator<CampaignPolicyValueObject> = {

}

type Panel = DetailPagePanelConstraint

const panelDescription: Record<Panel, string> = {
    Main: '기본',
}

const panelDetail: DetailPagePanelIndicator<CampaignPolicyValueObject, Panel> = {

}

export default function Detail(props: RouteContext) {
    return <>
        <DetailPage
            {...props}
            propertyDescription={CampaignPolicyValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={CampaignPolicyIO.get} />
    </>
}